import { KiteProgressIndicator } from '@kite/react-kite';
import { KeycloakLogin } from '@studio-toolkit/keycloak';
import { keycloakConfig } from 'config';
import { useLogin } from 'hooks';

const Login = ({ children }: { children: React.ReactNode }) => {
  const { handleLoginStop, handleLoginStart } = useLogin();

  return (
    <KeycloakLogin
      keycloakConfig={keycloakConfig}
      loadingPage={<KiteProgressIndicator id="keycloak" />}
      errorPage={<div>Unauthorized</div>}
      onLoginStart={handleLoginStart}
      onLoginStop={handleLoginStop}
    >
      <>{children}</>
    </KeycloakLogin>
  );
};

export default Login;
